import React from "react";
import { Box, IconButton } from "@mui/material";

const iconSizeMap = {
    xs: { xs: 14, sm: 16, md: 18 },
    sm: { xs: 16, sm: 18, md: 20 },
    md: { xs: 20, sm: 24, md: 28 },
    lg: { xs: 24, sm: 28, md: 32 },
    xl: { xs: 28, sm: 32, md: 36 },
    xxl: { xs: 32, sm: 36, md: 40 },
    xxxl: { xs: 36, sm: 40, md: 48 },
};

const buttonPaddingMap = {
    none: 0,
    dense: 0.5,  // 4px
    normal: 1,   // 8px
    comfortable: 1.5, // 12px
};

const AppIcon = ({
    icon: IconComponent,
    src,
    size = "md",
    onClick,
    disabled = false,
    disabledSx = {},   // Custom styles for disabled state
    buttonSize = "small",   // small | medium | large
    padding = "none",     // none | dense | normal | comfortable
    ariaLabel,
    sx = {}
}) => {
    const iconElement = (
        <Box
            component={src ? "img" : IconComponent}
            src={src}
            sx={{
                width: iconSizeMap[size],
                height: iconSizeMap[size],
                objectFit: "contain",
                ...sx,
                ...(disabled ? { opacity: 0.5, cursor: "not-allowed", ...disabledSx } : {}),

            }}
        />
    );

    if (onClick) {
        return (
            <IconButton
                onClick={onClick}
                disabled={disabled}
                size={buttonSize}
                aria-label={ariaLabel}
                sx={{
                    p: buttonPaddingMap[padding],
                }}
            >
                {iconElement}
            </IconButton>
        );
    }

    return iconElement;
};

export default AppIcon;
